<script setup>
defineProps({
  visible: { type: Boolean, default: true },
})

defineEmits(['scroll'])
</script>

<template>
  <button
    v-show="visible"
    @click="$emit('scroll')"
    class="scroll-nav-arrow"
    aria-label="Scroll to next section"
  >
    <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- Outer glow ring -->
      <circle cx="30" cy="30" r="28" stroke="url(#arrowGradient)" stroke-width="2" opacity="0.3" />
      <!-- Main circle background -->
      <circle
        cx="30"
        cy="30"
        r="24"
        fill="url(#arrowBgGradient)"
        stroke="url(#arrowGradient)"
        stroke-width="1.5"
      />
      <!-- Inner shine -->
      <ellipse cx="30" cy="24" rx="16" ry="10" fill="url(#arrowShineGradient)" opacity="0.4" />
      <!-- Arrow chevron -->
      <path
        d="M22 26 L30 34 L38 26"
        stroke="url(#arrowStrokeGradient)"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="arrow-chevron"
      />
      <!-- Decorative dots -->
      <circle cx="30" cy="40" r="1.5" fill="#F59E0B" opacity="0.6" />

      <defs>
        <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#D97706" />
          <stop offset="50%" stop-color="#F59E0B" />
          <stop offset="100%" stop-color="#FBBF24" />
        </linearGradient>
        <linearGradient id="arrowBgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#1e293b" />
          <stop offset="50%" stop-color="#334155" />
          <stop offset="100%" stop-color="#1e293b" />
        </linearGradient>
        <linearGradient id="arrowShineGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="white" />
          <stop offset="100%" stop-color="transparent" />
        </linearGradient>
        <linearGradient id="arrowStrokeGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#FBBF24" />
          <stop offset="50%" stop-color="#F59E0B" />
          <stop offset="100%" stop-color="#D97706" />
        </linearGradient>
      </defs>
    </svg>
  </button>
</template>

<style scoped>
.scroll-nav-arrow {
  position: fixed;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 52px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 1000;
  transition: all var(--transition-normal);
}

@media (min-width: 768px) {
  .scroll-nav-arrow {
    width: 60px;
    height: 60px;
    bottom: 8px;
  }
}

.scroll-nav-arrow svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 4px 12px rgba(217, 119, 6, 0.3));
  transition: filter var(--transition-normal);
}

.scroll-nav-arrow:hover svg {
  filter: drop-shadow(0 6px 20px rgba(217, 119, 6, 0.5));
}

.scroll-nav-arrow:hover {
  transform: translateX(-50%) scale(1.1);
}
</style>
